import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0h3v3H0zm5 0h3v3H5zM0 5h3v3H0zm5 0h3v3H5zm-5 5h3v3H0zm5 0h3v3H5z"
    }, null, -1)
  ]))]))
}
export default { render: render }